import { createFileRoute } from '@tanstack/react-router';

function KanbanPlatzhalter() {
  return (
    <div className="p-6">
      <p className="text-ink-soft">Kanban folgt in einer späteren SPEC.</p>
    </div>
  );
}

export const Route = createFileRoute('/kanban')({
  component: KanbanPlatzhalter
});
